import axios from 'axios';

/**
 * Quando true, nenhuma chamada HTTP/WebSocket ao backend-chatbot é feita.
 * Reative mudando para false quando quiser voltar a usar o chat.
 */
export const DISABLE_BACKEND_CHATBOT_CALLS = true;

/**
 * Em desenvolvimento: usa URL relativa (/) para o proxy funcionar
 * Em produção: usa REACT_APP_CHAT_API_URL do .env
 */
const isDevelopment = process.env.NODE_ENV === 'development';
const CHAT_API_BASE = isDevelopment
  ? ''
  : process.env.REACT_APP_CHAT_API_URL || 'http://localhost:4000';

export const CHAT_API_BASE_URL = `${CHAT_API_BASE}/api/v1/admin/chat`;
export const CHAT_AUTH_URL = `${CHAT_API_BASE}/api/v1/auth`;
export const WEBSOCKET_URL = `${CHAT_API_BASE}/chat`;

/**
 * Cliente HTTP dedicado ao backend-chatbot. Não usa a instância `api` do backend principal,
 * para que falhas do chatbot (ex.: serviço fora) nunca disparem o interceptor de redirect
 * para /service-unavailable.
 */
export const chatAxios = axios.create({
  baseURL: '',
  timeout: 15000,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});
